module.exports = __webpack_public_path__ + "static/media/03.cf142017.mp3";